import { writable, type Writable } from 'svelte/store';

import type { CalibrationModalState } from 'src/types/CalibrationDeviceModal';

export const showCalibrationHasStartedModal = writable<CalibrationModalState>({
	visible: false,
	device: null,
	channel: null,
});

export const doNotShowInitCalibrationModal: Writable<boolean> = writable<boolean>(false);
export const hideBluetoothSettingsToast: Writable<boolean> = writable<boolean>(false);
